// extracted by mini-css-extract-plugin
export default {"wrapper":"SlidesIndicator_wrapper__EN62A","dot":"SlidesIndicator_dot__hlM+j","inner-bar":"SlidesIndicator_inner-bar__xNzn6","active":"SlidesIndicator_active__82eba"};